import type { CodeNavOpContext } from './code-nav-op-context.js';
import type { CodeNavRequestMessage } from './types.js';

export type PreparedCodeNavRequest = CodeNavOpContext & {
  indexReady: boolean;
};

export function buildPreparedCodeNavBaseContext(
  msg: CodeNavRequestMessage,
  reqPath: string,
  sessionParentPath: string,
): Omit<PreparedCodeNavRequest, 'indexReady'> {
  return {
    msg,
    reqPath,
    sessionParentPath,
    line: typeof msg.line === 'number' ? msg.line : 1,
    column: typeof msg.column === 'number' ? msg.column : 0,
  };
}
